<div class="container-fluid service-bg from-top-pad">
    <!-- Titles -->
    <div class="row">
        <div class="col-md-12">
            <h1>
                <a href="#/account">{{'gen_my_account' | translate}}</a> / {{'gen_billing_history' | translate}}
            </h1>
            <hr>
        </div>
        <div class="col-md-12 my-5 clr-sec-text text-center" *ngIf="!billHistory?.length">
            <h2>{{'gen_no_data' | translate}}</h2>
        </div>
        <div class="col-md-12 my-3" infiniteScroll [infiniteScrollDistance]="2" (scrolled)="getBillingHistory()"
            *ngIf="billHistory?.length">
            <table mat-table [dataSource]="billHistory" class="mat-elevation-z8 w-100">
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef> {{'gen_date' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.updated | momentPipe:'DD/MM/YYYY'}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef> {{'gen_title' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.title}}
                    </td>
                </ng-container>

                <!-- Payment Method Column -->
                <ng-container matColumnDef="method">
                    <th mat-header-cell *matHeaderCellDef> {{'gen_payment_method' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <i class="{{element.paymentMethod | mapPaymentMethod}}"></i>
                    </td>
                </ng-container>

                <!-- Period Column -->
                <ng-container matColumnDef="period">
                    <th mat-header-cell *matHeaderCellDef> {{'gen_service_period' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.created | momentPipe:'DD/MM/YYYY'}} -
                        {{element.expirationDate | momentPipe:'DD/MM/YYYY'}}</td>
                </ng-container>

                <!-- Price Column -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef> {{'gen_price' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{env.priceUnit + element.price}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
</div>